export const FETCH_SCORESCHEMES_SUCCESS = 'FETCH_SCORESCHEMES_SUCCESS';
export const FETCH_SCORESCHEMES_REQUEST = 'FETCH_SCORESCHEMES_REQUEST';
export const FETCH_SCORESCHEMES_FAILURE = 'FETCH_SCORESCHEMES_FAILURE';